<template>
    <div class="content-wrapper-scroll">
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h5>Resolved Deviations</h5>
                        </div>
                        <div class="card-body">
                            <div class="row gutters">
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">From Date</div>
                                        <input class="form-control form-control-sm" type="date" v-model="meta.from_date" />
                                        <span v-if="errors.from_date" class="invalid-feedback">{{ errors.from_date[0] }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">To Date</div>
                                        <input class="form-control form-control-sm" type="date" v-model="meta.to_date" />
                                        <span v-if="errors.to_date" class="invalid-feedback">{{ errors.to_date[0] }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <search
                                            :class="{ 'is-invalid': errors.department_id }"
                                            :customClass="{ 'is-invalid': errors.department_id }"
                                            :initialize="meta.department_id"
                                            id="department_id"
                                            label="department_name"
                                            placeholder="Select Department"
                                            :data="departments"
                                            @input="departments => meta.department_id = departments"
                                        >
                                        </search>
                                        <span v-if="errors.department_id" class="invalid-feedback">{{ errors.department_id[0] }}</span>
                                        <div class="field-placeholder">Department</div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <search
                                            :class="{ 'is-invalid': errors.functional_id }"
                                            :customClass="{ 'is-invalid': errors.functional_id }"
                                            :initialize="meta.functional_id"
                                            id="functional_id"
                                            label="functional_name"
                                            placeholder="Select Functional"
                                            :data="functionals"
                                            @input="functionals => meta.functional_id = functionals"
                                        >
                                        </search>
                                        <span v-if="errors.functional_id" class="invalid-feedback">{{ errors.functional_id[0] }}</span>
                                        <div class="field-placeholder">Functional</div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <search
                                            :class="{ 'is-invalid': errors.section_id }"
                                            :customClass="{ 'is-invalid': errors.section_id }"
                                            :initialize="meta.section_id"
                                            id="section_id"
                                            label="section_name"
                                            placeholder="Select Section"
                                            :data="sections"
                                            @input="sections => meta.section_id = sections"
                                        >
                                        </search>
                                        <span v-if="errors.section_id" class="invalid-feedback">{{ errors.section_id[0] }}</span>
                                        <div class="field-placeholder">Section</div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <search
                                            :class="{ 'is-invalid': errors.frequency_id }"
                                            :customClass="{ 'is-invalid': errors.frequency_id }"
                                            :initialize="meta.frequency_id"
                                            id="frequency_id"
                                            label="frequency_name"
                                            placeholder="Select Frequency"
                                            :data="frequencies"
                                            @input="frequencies => meta.frequency_id = frequencies"
                                        >
                                        </search>
                                        <span v-if="errors.frequency_id" class="invalid-feedback">{{ errors.frequency_id[0] }}</span>
                                        <div class="field-placeholder">Frequency</div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-group field-wrapper">
                                        <input class="form-control" type="text" placeholder="Search for Template Name" v-model="meta.search" />
                                        <span class="input-group-text"> <i class="fas fa-search"></i> </span> &nbsp;
                                        <div class="field-placeholder">Template Name</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-actions-footer">
                                <div class="text-end">
                                    <button type="button" class="btn btn-primary" @click="search">
                                        Search
                                    </button>
                                    <button type="button" class="btn btn-danger" @click="reset">
                                        Reset
                                    </button>
                                    <a target="_blank" :href="$store.getters.pdfUrl+'report/resolved-deviations?plant_id='+meta.plant_id+'&from_date='+meta.from_date+'&to_date='+meta.to_date+'&department_id='+meta.department_id+'&functional_id='+meta.functional_id+'&section_id='+meta.section_id+'&frequency_id='+meta.frequency_id+'&search='+meta.search+'&report_type=PDF'" class="btn btn-success">
                                        PDF
                                    </a>
                                    <a target="_blank" :href="$store.getters.pdfUrl+'report/resolved-deviations?plant_id='+meta.plant_id+'&from_date='+meta.from_date+'&to_date='+meta.to_date+'&department_id='+meta.department_id+'&functional_id='+meta.functional_id+'&section_id='+meta.section_id+'&frequency_id='+meta.frequency_id+'&search='+meta.search+'&report_type=Excel'" class="btn btn-secondary">
                                        Excel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row gutters">
                                <div class="col-sm-12">
                                    <div class="table-responsive tabletop">
                                        <table class="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Template Name</th>
                                                    <th>Date Time</th>
                                                    <th>Component Type</th>
                                                    <th>Check Type</th>
                                                    <th>Default</th>
                                                    <th>LCL</th>
                                                    <th>UCL</th>
                                                    <th>Value</th>
                                                    <th>Note</th>
                                                    <th>Remark</th>
                                                    <th>Remarked By</th>
                                                    <th>Remark Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="resolved_components.length==0">
                                                    <td colspan="13" class="text-center">No records found</td>
                                                </tr>
                                                <tr v-for="(resolved_component,key) in resolved_components" :key="key">
                                                    <td>{{meta.from+key}}</td>
                                                    <td>{{resolved_component.template_name}}</td>
                                                    <td>{{resolved_component.date_time}}</td>
                                                    <td>{{resolved_component.component_type?.component_type_name}}</td>
                                                    <td>{{resolved_component.check_type?.check_type_name}}</td>
                                                    <td>{{resolved_component.default_value}}</td>
                                                    <td>{{resolved_component.lcl}}</td>
                                                    <td>{{resolved_component.ucl}}</td>
                                                    <td>{{resolved_component.value}}</td>
                                                    <td>{{resolved_component.note}}</td>
                                                    <td>{{resolved_component.remark}}</td>
                                                    <td>{{resolved_component?.remark_user?.name}}</td>
                                                    <td>{{resolved_component.remark_date_time}}</td>
                                                </tr>
                                            </tbody>
                                        </table>                             
                                    </div>
                                    <div class="form-actions-footer">
                                        <div class="text-end row">
                                            <div class="col-sm-2">
                                                <select class="form-control" v-model="meta.per_page" @change="onPerPageChange">
                                                    <option>10</option>
                                                    <option>15</option>
                                                    <option>20</option>
                                                    <option>25</option>
                                                    <option>30</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-10">
                                                <Pagination class="pagination pagination-sm" :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    import Search from "@/components/Search.vue";
    export default {
        components: { Pagination, Search },
        data() {
            return {    
                meta: {
                    plant_id:this.$store.getters.user.plant_id,
                    from_date:'',
                    to_date:'',
                    department_id:'',
                    functional_id: '',
                    section_id: '',
                    frequency_id: '',
                    search:'',
                    report_type:'Data',
                    order_by: "asc",
                    field: "user_equipment_component_id",                   
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                },
                remark: {
                    user_id:this.$store.getters.user?.user_id,
                    user_equipment_component_id:'',
                    remark:''
                },
                resolved_components:[],
                departments: [],
                functionals: [],
                sections: [],
                frequencies: [],
                errors:[],
            }
        },
        mounted() {
            let vm = this;
            vm.getDepartment();
            vm.index()
        },

        methods: {
            index() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "report/resolvedDeviations", data:vm.meta })
                .then(function (response) {
                    loader.hide();
                    vm.resolved_components = response.data.data;
                    vm.meta.totalRows = response.data.meta.total;
                    vm.meta.lastPage = response.data.meta.last_page;
                    vm.meta.from = response.data.meta.from;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            getDepartment() {
                let vm = this;
                vm.$store.dispatch("post", { uri: "getDepartmentsPlantWise", data:vm.meta })
                .then(function (response) {
                    vm.departments = response.data.data;
                    vm.getFunctions();
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            getFunctions() {
                let vm = this;
                vm.$store.dispatch("post", { uri: "getFunctionalsPlantWise", data:vm.meta })
                .then(function (response) {
                    vm.functionals = response.data.data;
                    vm.getSections();
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            getSections() {
                let vm = this;
                vm.$store.dispatch("post", { uri: "getSectionsPlantWise", data:vm.meta })
                .then(function (response) {
                    vm.sections = response.data.data;
                    vm.getFrequencies();
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            getFrequencies() {
                let vm = this;
                vm.$store.dispatch("post", { uri: "getFrequenciesPlantWise", data:vm.meta })
                .then(function (response) {
                    vm.frequencies = response.data.data;
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            }, 

            addRemark(user_equipment_component) {
                let vm = this;
                vm.remark.user_equipment_component_id = user_equipment_component?.user_equipment_component_id;
                vm.remark.remark = user_equipment_component?.remark;
            },

            updateRemark() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "updateDeviatedRemarks", data: vm.remark };
                vm.$store.dispatch("post", uri)
                .then(function () {
                    loader.hide();
                    vm.remark.user_equipment_component_id = "";
                    vm.remark.remark = "";
                    vm.$store.dispatch("success", "Remark is successfully updated");
                    vm.index()
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
            sort(field) {
                this.meta = field;
                this.meta.order_by = this.meta.order_by=='asc' ? 'desc' : 'asc';
                this.index();
            },
            search() {
                this.meta.page = 1;
                this.index();
            },

            reset() {
                let vm = this;
                vm.meta.from_date = '';
                vm.meta.to_date = '';
                vm.meta.department_id = '';
                vm.meta.functional_id = '';
                vm.meta.section_id = '';
                vm.meta.frequency_id = '';
                vm.meta.search = '';
                vm.search()
            }
        }
    }
</script>

<style scoped>
    .btnn {
        margin-top: 0.5rem;
    }
</style>
